import { error as reportError } from '@xhs/logger';
import { commonChecks } from '@xhs/ozone-detector';
import { SchemaErrorCode } from './type';
export default class SchemaError extends Error {
    constructor(code, ...params) {
        super(...params);
        this.name = 'SchemaError';
        this.code = code;
        if (commonChecks.isXHS && this.code === SchemaErrorCode.UnKnow && process.env.BUILD_ENV === 'production') {
            reportError(this);
        }
    }
}
